var exports = {
  "i": "xaee3c4fa--8257d7--wrapper",
  "X": "xaee3c4fa--8257d7--_white",
};

module.exports = exports;
